import { downloadDataViewCsv } from "./downloadDataViewCsv";
import { formatHeaderName } from "./dataViewUtils";

const stripPrivateFields = (record = {}) =>
  Object.fromEntries(
    Object.entries(record).filter(
      ([key]) => !String(key).startsWith("_") && key !== "manual_entries"
    )
  );

const buildRecordHeaders = (record = {}) =>
  Object.keys(stripPrivateFields(record)).sort();

export const downloadVisibleDataViewRows = ({
  rows = [],
  datasetName = "data",
  currentPage = 1,
  fileLabel,
}) => {
  const cleanedRows = rows.map((row) => stripPrivateFields(row));
  const headers = buildRecordHeaders(cleanedRows[0] || {});

  downloadDataViewCsv({
    rows: cleanedRows,
    headers,
    datasetName: fileLabel || datasetName,
    currentPage,
  });
};

export const downloadSingleDataViewRecord = ({
  record = null,
  datasetName = "record",
  recordId = "record",
}) => {
  const cleanedRecord = stripPrivateFields(record || {});
  const headers = buildRecordHeaders(cleanedRecord);

  if (!headers.length) {
    return;
  }

  const csvRows = headers.map((header) => {
    const value = cleanedRecord[header];
    const serializedValue =
      value === null || value === undefined || value === ""
        ? ""
        : typeof value === "object"
          ? JSON.stringify(value)
          : String(value);

    return `"${formatHeaderName(header).replace(/"/g, '""')}","${serializedValue.replace(/"/g, '""')}"`;
  });

  const csvContent = ['"Field","Value"', ...csvRows].join("\n");
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  const normalizedDatasetName = datasetName.toLowerCase().replace(/\s+/g, "_");

  link.setAttribute("href", url);
  link.setAttribute(
    "download",
    `${normalizedDatasetName}_${String(recordId).replace(/[^\w.-]+/g, "_")}.csv`
  );
  link.style.visibility = "hidden";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const buildBulkDownloadBatchOptions = (totalRecords, batchSize = 10000) => {
  const total = Number(totalRecords) || 0;

  if (total <= 0) {
    return [];
  }

  const batchOptions = [];
  for (let start = 0; start < total; start += batchSize) {
    const end = Math.min(start + batchSize, total);
    batchOptions.push({
      value: `${start}:${end}`,
      start,
      end,
      label: `Records ${start + 1}-${end.toLocaleString()}`,
    });
  }

  return batchOptions;
};
